import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, unref as _unref, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-90a115f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<svg width=\"100%\" height=\"100%\" viewBox=\"0 0 200 100\" xmlns=\"http://www.w3.org/2000/svg\" data-v-90a115f8><defs data-v-90a115f8><linearGradient id=\"grad2\" x1=\"0%\" y1=\"0%\" x2=\"100%\" y2=\"0%\" data-v-90a115f8><stop offset=\"0%\" style=\"stop-color:#f03200;stop-opacity:1;\" data-v-90a115f8></stop><stop offset=\"20%\" style=\"stop-color:#ff6c00;stop-opacity:1;\" data-v-90a115f8></stop><stop offset=\"40%\" style=\"stop-color:#fac800;stop-opacity:1;\" data-v-90a115f8></stop><stop offset=\"60%\" style=\"stop-color:#37fdff;stop-opacity:1;\" data-v-90a115f8></stop><stop offset=\"80%\" style=\"stop-color:#00fa99;stop-opacity:1;\" data-v-90a115f8></stop></linearGradient></defs><path d=\"M 30,100 a 70,70 0 0,1 140,0\" fill=\"none\" stroke=\"url(#grad2)\" stroke-width=\"13\" data-v-90a115f8></path><text y=\"90%\" x=\"3%\" font-size=\"8\" fill=\"#fff\" data-v-90a115f8>1级</text><text y=\"40%\" x=\"17%\" font-size=\"8\" fill=\"#fff\" data-v-90a115f8>2级</text><text y=\"18%\" x=\"47%\" font-size=\"8\" fill=\"#fff\" data-v-90a115f8>3级</text><text y=\"40%\" x=\"76%\" font-size=\"8\" fill=\"#fff\" data-v-90a115f8>4级</text><text y=\"90%\" x=\"90%\" font-size=\"8\" fill=\"#fff\" data-v-90a115f8>5级</text></svg>", 1)
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = { class: "center-item" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "indicators" }
const _hoisted_6 = { class: "indicator-card" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "red-point" }, null, -1))
const _hoisted_8 = { class: "indicator-card" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "red-point" }, null, -1))

import { gradeToDescription } from '@/utils/utilsHandle';
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  props: {
  level: {
    type: Number,
    default: 1,
  },
  trendLevel: {
    type: Number,
    default: 0,
  },
  highRiskModuleCount: {
    type: Number,
    default: 0,
  },
  highRiskKriMetricsCount: {
    type: Number,
    default: 0,
  },
},
  setup(__props) {



const chartContainer = ref(null as any);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "chart-container",
    ref_key: "chartContainer",
    ref: chartContainer
  }, [
    _createElementVNode("div", {
      style: _normalizeStyle({ height: (chartContainer.value?.clientWidth || 300) / 2 + 'px' })
    }, _hoisted_2, 4),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _createElementVNode("img", {
            src: require(`@/assets/images/home/grade-${__props.level || 1}.png`)
          }, null, 8, _hoisted_4),
          _createElementVNode("span", null, _toDisplayString(__props.level), 1)
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["year-on-year", { red: __props.trendLevel < 0 }])
        }, _toDisplayString(_unref(gradeToDescription)(__props.trendLevel || 0)), 3)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("span", null, "高风险模块 " + _toDisplayString(__props.highRiskModuleCount), 1)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("span", null, "高风险指标 " + _toDisplayString(__props.highRiskKriMetricsCount), 1)
      ])
    ])
  ], 512))
}
}

})